.sectionWrapper {
	background: #006 url("/images/home/pillar-texture-mobile-blue-light-top.png") no-repeat center center;
	background-size: 100% 100%;
	color: #000;
	padding: 17.75% 0;

	.sectionTitle {
		font-size: 12.25vw;
	}

	.sectionCopy {
		font-family: "Bourgeois W00 Medium", sans-serif;
		text-transform: normal;
		font-weight: 700;
		margin-bottom: 0;
		font-size: 6vw;
		line-height: 1.35;
		background: #fce79c;
		background: -moz-linear-gradient(top, #fce79c 0, #fa9323 100%);
		background: -webkit-linear-gradient(top, #fce79c 0, #fa9323 100%);
		background: linear-gradient(to bottom, #fce79c 0, #fa9323 100%);
		margin-bottom: 5%;
		padding: 5%;
		filter: drop-shadow(4px 4px 0 black);
		transform: rotate(358deg);
		border: 2px solid #000;
	}
}

@media screen and (min-width: 768px) {
	.sectionWrapper {
		background: #006 url("/images/home/pillar-texture-tablet-blue-light-bottom.png") no-repeat center center;
		background-size: cover;
		padding: 22.5% 0;

		.sectionTitle {
			font-size: 9vw;
			line-height: 1;
		}

		.sectionCopy {
			font-size: 3.15vw;
			line-height: 1.35;
		}
	}
}

@media screen and (min-width: 1024px) {
	.sectionWrapper {
		background: #006 url("/images/home/pillar-texture-tablet-blue-light-bottom.png") no-repeat center center;
		background-size: cover;
		padding: 5.85% 0;

		.sectionTitle {
			font-size: 4.25vw;
		}

		.sectionCopy {
			font-size: 1.75vw;
		}
	}
}
